<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<section class="page">
	<section class="page-header">
		<div class="back">
			<globalictcc-button
				label="Back to toolbox"
				[textOnly]="true"
				iconName="arrow-left"
				(handleClick)="onGoBack()"
			/>
		</div>

		<div class="page-title">
			<span class="page-name">What if</span>

			<span class="page-description">
				Create your own scenarios by following the below steps:
			</span>
		</div>
	</section>

	<section class="container">
		<section class="sub-section">
			<div class="sub-section-header">
				<span class="sub-section-title">1. Choose your resource type</span>

				<span class="sub-section-description">
					Select the resource type to proceed with the detailed configuration.
				</span>
			</div>

			<form [formGroup]="resourceForm">
				<div class="form-container">
					<div class="adjacent-inputs">
						<globalictcc-dropdown
							label="Resource type"
							formControlName="resourceType"
							[options]="resourceTypes"
						/>

						<globalictcc-button
							label="Apply"
							(handleClick)="onResourceApply()"
							[disabled]="resourceForm.invalid"
						/>
					</div>
				</div>
			</form>
		</section>

		<div><router-outlet /></div>
	</section>
</section>
